import { faCamera } from '@fortawesome/pro-light-svg-icons/faCamera'
import Icon from '@space-core/components/icon'
import Image from '@space-core/components/image'
import productDefaultImage from '@space-shell/assets/images/productDefaultImage.svg'
import clsx from 'clsx'

type ModuleCardThumbnailProps = {
  image?: string
}

const ModuleCardThumbnail = ({ image }: ModuleCardThumbnailProps) => {
  const hasImage = Boolean(image)

  if (!hasImage) {
    return <Icon aria-hidden icon={faCamera} className='_text-gray-300 _text-8' />
  }

  return (
    <Image
      alt=''
      aria-hidden
      errorSrc={productDefaultImage}
      objectPosition='center'
      src={image}
      objectFit={hasImage ? 'cover' : 'contain'}
      className={clsx({ '_w-full _h-full': hasImage, '_w-9 _h-9': !hasImage })}
    />
  )
}

export default ModuleCardThumbnail
